import axios from "axios";
import { debounce } from "lodash";
import * as React from "react";
import { MyCard } from "./MyCard";
import { AssetImageLink } from "./AssetImageLink";
import { DataTable } from "./ui";
import useAssetData from "./useAssetData";

export function Assets() {
  const [assets, setAssets] = React.useState<string[]>([]);
  const [gatewayURL, setGatewayURL] = React.useState(
    "https://cloudflare-ipfs.com/ipfs/"
  );
  const [filterText, setFilterText] = React.useState("");
  const [page, setPage] = React.useState(1);
  const PAGE_SIZE = 25;

  const debouncedSearch = React.useRef(
    debounce(async (value: string) => {
      setFilterText(value);
      setPage(1);
    }, 300)
  ).current;

  React.useEffect(() => {
    axios.get("/gui-settings").then((response) => {
      if (response.data.ipfs_gateway) setGatewayURL(response.data.ipfs_gateway);
    });
    axios.get("/api/assets").then((r) => setAssets(r.data || []));
  }, []);

  if (!assets.length) {
    return (
      <div className="page">
        <p className="muted">Loading assets…</p>
      </div>
    );
  }

  const assetsToShow = assets.filter((asset: string) => {
    if (!filterText) return true;
    return asset.toUpperCase().startsWith(filterText.toUpperCase());
  });
  const displayed = assetsToShow.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
  const pages = Math.max(1, Math.ceil(assetsToShow.length / PAGE_SIZE));

  return (
    <div className="page stack">
      <div className="kicker">Native assets</div>
      <h1 style={{ fontSize: 28, margin: 0 }}>Tokens on Telestai</h1>
      <p className="muted">
        Native Telestai assets: issue, reissue, unique names, IPFS metadata.{" "}
        {assets.length.toLocaleString()} names indexed.
      </p>
      <MyCard
        header={"Assets · " + assets.length.toLocaleString()}
        body={
          <>
            <input
              className="filter"
              placeholder="Filter by name"
              onChange={(e) => debouncedSearch(e.target.value)}
            />
            <div className="pager">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)}>
                Previous
              </button>
              <span className="dim">
                Page {page} / {pages}
              </span>
              <button disabled={page >= pages} onClick={() => setPage(page + 1)}>
                Next
              </button>
            </div>
            <DataTable
              headers={["#", "Name", "IPFS", "Amount"]}
              rows={displayed.map((assetName: string) => [
                assets.indexOf(assetName) + 1,
                <a href={"index.html?route=ASSET&name=" + encodeURIComponent(assetName)}>
                  {assetName}
                </a>,
                <AssetImageLink assetName={assetName} gatewayURL={gatewayURL} />,
                <AssetAmount assetName={assetName} />,
              ])}
            />
          </>
        }
      />
    </div>
  );
}

function AssetAmount({ assetName }: { assetName: string }) {
  const asset = useAssetData(assetName);
  if (!asset) return <span className="dim">…</span>;
  return <span>{Number(asset.amount).toLocaleString()}</span>;
}
